import { DAPStatusEnum } from '@ytl/common-model';
import { useTheme } from '@ytl/common-web';
import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { OnboardingView } from '../modules/onboarding/OnboardingView';
import { OnboardingWebView } from '../modules/onboarding/OnboardingWebView';
import { OnboardingMethod } from '../shared/@types/onboardingMethods';
import { WidgetEvent } from '../shared/@types/widgetEvents';
import { getConfig } from '../shared/data/config';
import { onWidgetEvent } from '../shared/utils/emitData';

type OnboardingPageProps = {
  method?: OnboardingMethod;
};

export const OnboardingPage = ({ method }: OnboardingPageProps) => {
  const { isWebView } = useTheme();
  const location = useLocation();
  const onboardingKey = `${location.pathname}:${method ?? 'default'}`;

  useLayoutEffect(() => {
    document.documentElement.classList.add('register-page');
    return () => {
      document.documentElement.classList.remove('register-page');
    };
  }, []);

  useEffect(() => {
    return onWidgetEvent(data => {
      if (
        (data.eventName === WidgetEvent.ProcessFinished && data.eventValue?.banned) ||
        (data.eventName === WidgetEvent.DAPStatusReport && data.eventValue?.error === DAPStatusEnum.NO_SUBSCRIBER_FOUND)
      ) {
        document.documentElement.classList.remove('register-page');
      }
    });
  }, []);

  const exitButtonAction = () => {
    if (isWebView) {
      window.location.href = getConfig().closeWebViewUrl;
    } else {
      const url = getConfig().webLoginUrl;
      window.location.href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    }
  };

  return (
    <>
      {isWebView && (
        <OnboardingWebView
          key={onboardingKey}
          exitButtonAction={exitButtonAction}
          method={method}
        />
      )}
      {!isWebView && (
        <OnboardingView
          key={onboardingKey}
          exitButtonAction={exitButtonAction}
          method={method}
        />
      )}
    </>
  );
};
